import React, { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import JobApplication from '../../HomePage/JobApplication';
import './Careers.css';

const Careers = () => {
  const { t } = useLanguage();
  const [showApplication, setShowApplication] = useState(false);

  return (
    <div className="careers-page">
      <Navbar />
      
      <section className="page-hero">
        <div className="container">
          <h1>{t('careers.joinOurTeam', 'Join Our Team')}</h1>
          <p>{t('careers.buildYourCareer', 'Build your career with us')}</p>
        </div>
      </section>

      <section className="careers-content">
        <div className="container">
          <div className="requirements-section">
            <h2>{t('careers.whatWeLookingFor', 'What We\'re Looking For')}</h2>
            <div className="requirements-list">
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.reliablePunctual', 'Reliable and punctual')}</p>
              </div>
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.attentionToDetail', 'Attention to detail')}</p>
              </div>
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.goodPhysicalCondition', 'Good physical condition')}</p>
              </div>
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.professionalAttitude', 'Professional attitude')}</p>
              </div>
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.workIndependently', 'Ability to work independently')}</p>
              </div>
              <div className="requirement-item">
                <span className="check-icon">✓</span>
                <p>{t('careers.validWorkPermit', 'Valid work permit (if applicable)')}</p>
              </div>
            </div>
          </div>

          <div className="apply-section">
            <h2>{t('careers.readyToApply', 'Ready to Apply?')}</h2>
            <p>{t('careers.fillApplicationForm', 'Fill out the application form below and we\'ll get back to you soon.')}</p>
            <button 
              className="btn btn-primary"
              onClick={() => setShowApplication(!showApplication)}
            >
              {showApplication ? t('careers.hideApplicationForm', 'Hide Application Form') : t('careers.showApplicationForm', 'Show Application Form')}
            </button>
          </div>

          {showApplication && (
            <div className="application-container">
              <JobApplication onClose={() => setShowApplication(false)} />
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Careers;


